import React, {Component} from "react";
import {connect} from "react-redux";
import './PhaseSummary.scss'
import LoadingButton from "../../../shared/ui/LoadingButton";
import oitsActions from "../../store/oits/action-creators/index";
import {ApiGetRaw, ApiPost} from "../../../shared/services/api-service";

class PhaseSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    }
  }

  getFormName(type) {
    let form = this.props.forms.find(f => f.type === type && f.status === 'current')
    return form ? form.name: type
  }
  getColorForStatus(status, count) {
    switch (status) {
      case 'completed':
        return count > 0 ? '#066e1b': '#737373'
      case 'acknowledged':
      case 'submitted':
        return count > 0 ? '#a28d21': '#066e1b'
      case 'draft':
        return count > 0 ? '#8d0606': '#066e1b'
      case 'scheduled':

        return count > 0 ? '#8d0606': '#066e1b'
    }
  }

  countForStatus(summary, status) {
    let statusSummary = summary.find(s => s.status === status);
    return statusSummary? statusSummary.count : 0;
  }
  getForStatus(summary, status, text) {
    let count = this.countForStatus(summary, status)
    return <div style={{color: this.getColorForStatus(status, count)}}><b>{text}</b>: {count}</div>
  }

  completedCount(summary) {
    return this.countForStatus(summary,'completed') + this.countForStatus(summary,'submitted') + this.countForStatus(summary,'acknowledged')
  }
  onAdvanceNewPhase(clearReports = false) {
    let openPhaseId = this.props.phase.trainingPhaseGuid;
    let nextPhaseId = this.props.nextPhase? this.props.nextPhase.trainingPhaseGuid: null

    this.setState({
      isLoading: true
    })
    let promises = []
    if(clearReports) {
      promises.push(ApiPost(`/api/v1/training-phases/${openPhaseId}/clear-reports`))
    }
    promises.push(this.props.closePhase(openPhaseId))
    if(nextPhaseId) {
      promises.push(this.props.openPhase(nextPhaseId))
    }

    return Promise.all(promises)
      .then(() => {
        this.props.onPhaseUpdated && this.props.onPhaseUpdated()
        this.setState({
          isLoading: false
        })
      })
      .catch(() => {
        this.setState({
          isLoading: false
        })
      })
  }

  get hasDraftsOrSchedules() {
    return Object.keys(this.props.phaseSummary)
      .filter(key => !!this.props.phaseSummary[key].find(ps => ps.count > 0 && ['draft', 'scheduled'].includes(ps.status) ))
      .length > 0
  }
  render() {
    let {phase, nextPhase, phaseSummary, oit} = this.props
    return (
      <div className="phase-summary">
        {!this.props.compact && <h5>{oit.getFullName()} - {phase.header}</h5>}
        {!this.props.compact && nextPhase && <h6><b>Next phase - {nextPhase.header}</b></h6>}
        <br/>
        {Object.keys(phaseSummary).map((key) => (
          this.props.compact ? (
              <div key={key} className="phase-summary-form-type">
                <h6>{this.getFormName(key)}</h6>
                <div style={{color: '#066e1b'}}><b>Completed: {this.completedCount(phaseSummary[key])}</b></div>
                <div style={{color: '#a28d21'}}><b>Scheduled: {this.countForStatus(phaseSummary[key],'scheduled')}</b></div>
              </div>
            ):
            (
              <div key={key} className="phase-summary-form-type">
                <h6>{this.getFormName(key)}</h6>
                {this.getForStatus(phaseSummary[key], 'completed', "Completed")}
                {this.getForStatus(phaseSummary[key], 'acknowledged', "Waiting approval")}
                {this.getForStatus(phaseSummary[key], 'submitted', "Waiting acknowledgement")}
                {this.getForStatus(phaseSummary[key], 'scheduled', "Scheduled")}
                {this.getForStatus(phaseSummary[key], 'draft', "Draft")}
              </div>
            )
        ))}
        {!this.props.compact && (
          <div className={'flex'}>
            {this.hasDraftsOrSchedules && <LoadingButton isLoading={this.state.isLoading} secondary={true} onClick={() => this.onAdvanceNewPhase(true)}
                            text="Clear drafts and scheduled and activate next phase"/>}
            <LoadingButton isLoading={this.state.isLoading} primary={true} onClick={() => this.onAdvanceNewPhase()} text="Activate next phase"/>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    forms: state.forms.list,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closePhase: (phaseGuid) => {
      return dispatch(oitsActions.closePhase(phaseGuid));
    },
    openPhase: (phaseGuid) => {
      return dispatch(oitsActions.openPhase(phaseGuid));
    },
    reopenPhase: (phaseGuid) => {
      return dispatch(oitsActions.reopenPhase(phaseGuid));
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(PhaseSummary)
